import { render, staticRenderFns } from "./PageSubHeader.vue?vue&type=template&id=49270e24&scoped=true&"
import script from "./PageSubHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./PageSubHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PageSubHeader.vue?vue&type=style&index=0&id=49270e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49270e24",
  null
  
)

export default component.exports